import { openDB } from 'idb';

const DB = openDB('inv-cache', 1, {
  upgrade(d) {
    if (!d.objectStoreNames.contains('products')) {
      const s = d.createObjectStore('products', { keyPath: 'id' });
      s.createIndex('barcode', 'barcode');
    }
    if (!d.objectStoreNames.contains('categories'))
      d.createObjectStore('categories', { keyPath: 'id' });
  },
});

export const cache = {
  async setProducts(list) {
    const d = await DB; const tx = d.transaction('products','readwrite');
    await tx.store.clear(); await Promise.all(list.map(p => tx.store.put(p))); await tx.done;
  },
  async setCategories(list) {
    const d = await DB; const tx = d.transaction('categories','readwrite');
    await tx.store.clear(); await Promise.all(list.map(c => tx.store.put(c))); await tx.done;
  },
  async getAllProducts()    { return (await DB).getAll('products'); },
  async getAllCategories()  { return (await DB).getAll('categories'); },
  async upsertProduct(p)   { return (await DB).put('products', p); },
  async removeProduct(id)  { return (await DB).delete('products', id); },
  async getByBarcode(code) {
    const d = await DB;
    return d.transaction('products').store.index('barcode').get(code);
  },
  async searchProducts(q) {
    const all = await this.getAllProducts();
    const lo = q.toLowerCase();
    return all.filter(p => p.name?.toLowerCase().includes(lo) || p.barcode?.includes(q));
  },
};
